import React,{useEffect} from 'react'
import styled from 'styled-components'
import Vimeo from '@vimeo/player';
import { useMutation} from '@apollo/react-hooks'
import { courseMutations } from '../../graphql/mutations/'


const VideoWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
`

const Video = ({ content, courseId, id ,presentation}) => {


  useEffect(() => {
    try{
        let iframe = document.querySelector('iframe')   
        let player = new Vimeo(iframe);

        player.on('play', function() {
            if (!presentation) {
              id && courseId && adicionaProgresso({
                    variables: {
                        conteudoId:id,
                        cursoId:courseId
                    }
                })
            }
          });  
         
    }catch(e) {
        console.log(e)
    }

}, []) 


const [adicionaProgresso] = useMutation(courseMutations.ADD_PROGRESS)

  return (
    <VideoWrapper>
      <iframe title={content.codigo} src={`https://player.vimeo.com/video/${content.codigo}`} width="100%" height="100%" className="content" frameborder="0" allow="autoplay; fullscreen" allowfullscreen />
    </VideoWrapper>
  )
}

export default Video
